/** Width for filter-field dropdown menus (invitee email, event types, packages, etc.). */
export const FILTER_FIELD_DROPDOWN_WIDTH = 520;

/** Width for the meetings date-range picker dropdown (calendar + bookmarks). */
export const DATE_RANGE_DROPDOWN_WIDTH = 620;

// From React-Aria popover styles

/**
 * Applied to `#meetings-filter-menu-portal` so portaled menus stack above the FilterMenu popover.
 */
export const portaledMenuPortalRootCss = "p1i99d80";
export const portaledMenuShellCss = "pmff9wc";
export const filterFieldDropdownMenuCss = "f4hql0j";
export const dateRangeDropdownMenuCss = "d1om9c3";

/**
 * Phone date picker scroll shell. CUI's mobile RangeCalendar navigates months via
 * scrollIntoView; the scroll container must be this fixed shell, not an inner panel
 * with overflow: hidden (see Container in dropdown/styles.js).
 */
export const dateRangeDropdownScrollShellCss = "d1g83jie";

/** Inner menu chrome on phone — scrolling is handled by dateRangeDropdownScrollShellCss. */
export const dateRangeDropdownMenuPhoneCss = "dly6j6b";

require("./portaled_menu_styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./portaled_menu_styles.js");